import { createRouter, createWebHistory } from 'vue-router';
// eslint-disable-next-line import/no-cycle
import { useAuthStore } from '@/store/auth/authModule';
import { parseConStr } from '~utils/parentAuth';

// eslint-disable-next-line import/no-cycle
import routes from './routes';

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const store = useAuthStore();
  if (to.name === 'Catch') {
    store.authFromParent(parseConStr(to.query.con_str));
    next();
    return;
  }
  const isAuth = store.getIsAuth;
  if (!isAuth) {
    await useAuthStore().autenticate();
  }
  const toCompare = store.isAuth;
  if (!toCompare && to.path !== '/login') {
    next({ path: '/login' });
  } else if (toCompare && to.path === '/login') next({ path: '/dashboard' });
  else next();
});

export default router;
